"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionsContributionSection = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var commonFunctions_1 = require("../../commonFunctions");
var portal_core_1 = require("@ferry/portal-core");
var PromotionsContributionSection = /** @class */ (function (_super) {
    __extends(PromotionsContributionSection, _super);
    function PromotionsContributionSection(props) {
        return _super.call(this, props) || this;
    }
    PromotionsContributionSection.prototype.render = function () {
        var _a;
        if (((_a = this.props.interaction.promotions) === null || _a === void 0 ? void 0 : _a.promotionsApplied) === true) {
            var promotions = this.props.interaction.promotions;
            var voucherAmountTotal = promotions.promotionsTotalValue;
            var tcsUrl = undefined;
            var hasFreeInsurance = undefined;
            var brandName = (0, portal_core_1.getPrettifiedInteractionBrandName)(this.props.interaction.brandName);
            // TODO: no requirements for stacking have been provided, so selecting first promotion by default. // Probably will need to change when we have more requirements
            if (promotions && promotions.promotionsDetails.length > 0) {
                tcsUrl = promotions.promotionsDetails[0].termsAndConditionsUrl;
                hasFreeInsurance = promotions.promotionsDetails[0].promotionType === "FREE_INSURANCE";
            }
            return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [hasFreeInsurance ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["As a thank you, ", brandName, " are covering the cost of your annual car insurance."] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["As a thank you, ", brandName, " are contributing ", (0, commonFunctions_1.getAmountWithDecimalDigits)(voucherAmountTotal), " towards the cost of your annual car insurance.\u00A0"] })), this.renderTermsAndConditions(tcsUrl)] }));
        }
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    PromotionsContributionSection.prototype.renderTermsAndConditions = function (tcsUrl) {
        if (tcsUrl) {
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Please read the ", (0, jsx_runtime_1.jsx)("a", { className: "text-decoration-underline", target: "_blank", href: tcsUrl, children: "T&C\u2019s" }), "."] }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    return PromotionsContributionSection;
}(React.Component));
exports.PromotionsContributionSection = PromotionsContributionSection;
//# sourceMappingURL=PromotionContributionSection.js.map